const initialState = {
  // Login Case
  isLoginUser: false,

  // Forget Password Case 
  isPasswordForgeting: false,

  // Reset Password Case
  isPasswordResetting: false,
};

const LoginReducer = (state = initialState, action) => {
  switch (action.type) {
    // Login Case
    case "LOGIN_REQUEST":
      return {
        ...state,
        isLoginUser: true,
      };
    case "LOGIN_SUCCESS":
      return {
        ...state,
        isLoginUser: false,
      };
    case "LOGIN_ERROR":
      return {
        ...state,
        isLoginUser: false,
      };
    // Forget Password Case 
    case "FORGET_PASSWORD_REQUEST":
      return {
        ...state,
        isPasswordForgeting: true,
      };
    case "FORGET_PASSWORD_SUCCESS":
      return {
        ...state,
        isPasswordForgeting: false,
      };
    case "FORGET_PASSWORD_ERROR":
      return {
        ...state,
        isPasswordForgeting: false,
      };
    // Reset Password Case 
    case "RESET_PASSWORD_REQUEST":
      return {
        ...state,
        isPasswordResetting: true,
      };
    case "RESET_PASSWORD_SUCCESS":
      return {
        ...state,
        isPasswordResetting: false,
      };
    case "RESET_PASSWORD_ERROR":
      return {
        ...state,
        isPasswordResetting: false,
      };
    default:
      return state;
  }
};

export default LoginReducer;
